/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Open_AskInputs */

const en_us2_search_open_ask = /** @type {(inputs: Search_Open_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask`)
};

const pt_br2_search_open_ask = /** @type {(inputs: Search_Open_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntar`)
};

const es_419_search_open_ask = /** @type {(inputs: Search_Open_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntar`)
};

const pt_pt2_search_open_ask = /** @type {(inputs: Search_Open_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntar`)
};

const fr_fr2_search_open_ask = /** @type {(inputs: Search_Open_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander`)
};

const de_de2_search_open_ask = /** @type {(inputs: Search_Open_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragen`)
};

const it_it2_search_open_ask = /** @type {(inputs: Search_Open_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiedi`)
};

/**
* | output |
* | --- |
* | "Ask" |
*
* @param {Search_Open_AskInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_open_ask = /** @type {((inputs?: Search_Open_AskInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Open_AskInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_open_ask(inputs)
	if (locale === "es-419") return es_419_search_open_ask(inputs)
	if (locale === "pt-PT") return pt_pt2_search_open_ask(inputs)
	if (locale === "fr-FR") return fr_fr2_search_open_ask(inputs)
	if (locale === "de-DE") return de_de2_search_open_ask(inputs)
	if (locale === "it-IT") return it_it2_search_open_ask(inputs)
	return en_us2_search_open_ask(inputs)
});
export { search_open_ask as "search.open_ask" }